import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { calendar, editBook, leftArrow } from "../../common/Assets/imgs";
import { TimePicker } from "@mui/x-date-pickers";
// import { FaClock } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
//  import DateRangeSelector from "../../Components/Popup/DatePicker/DatePicker";
// import DateRangeSelector from "../../Components/Popup/DatePicker/DatePicker";
const BookingAssign = () => {
  const navigation = useNavigate();
  //   const [openCalendar, setOpenCalendar] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");
  const [bookingData, setbookingData] = useState(null);
  const hiddenTimeRef = useRef(null);
  const location = useLocation();
  const data = location?.state?.data;
  console.log("dataa", data);
  const type = location?.state?.type;
  const [transportList, setTransportList] = useState([]);
  const [vehicleListsByIndex, setVehicleListsByIndex] = useState({});
  const [vehicleNumbersByIndex, setVehicleNumbersByIndex] = useState({});
  const [driverListsByIndex, setDriverListsByIndex] = useState({});
  const loadedDriversRef = useRef({});
  const loadedVehicleListsRef = useRef({});
  const loadedVehicleNumbersRef = useRef({});
  const [tabName, setTabName] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
  const [dropLocation, setDropLocation] = useState("");

  const [vehicles, setVehicles] = useState([]);
  const [vehiclesId, setVehiclesID] = useState(null);
  const [popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [formattedTime, setFormattedTime] = useState("");

  const canEditTime = tabName === "Request" || tabName === "Assigned";

  const formatTimeToAmPm = (value) => {
    if (!value) return "";
    const [hours, minutes] = value.split(":");
    let h = parseInt(hours, 10);
    if (Number.isNaN(h)) return "";
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    h = h ? h : 12;
    return `${h}:${minutes} ${ampm}`;
  };

  const [form, setForm] = useState({
    trip_id: "",
    user_name: "",
    mobile: "",
    user_type: "",
    pickup: "",
    drop: "",
    vehicle_type: "",
    vehicle_count: "",
    max_volume: "",
    start_time: "",
    total_amount: "",
    paid_amount: "",
    balance_amount: "",
    reason: "",
    status: "",
    cancelled_reason: "",
  });

  useEffect(() => {
    if (data) {
      setForm({
        trip_id: data?.trip_code || "",
        user_name: data?.user_name || "",
        mobile: data?.user_mobile || "",
        user_type: data?.user_special_user === "False" || "",
        pickup: data?.trip_pickup || "",
        drop: data?.trip_drop || "",
        vehicle_type: data?.vehicle_type || "",
        vehicle_count: data?.vehicle_count || "",
        max_volume: data?.vehicle_max_ton || "",
        start_time: data?.created_at || "",
        total_amount: data?.total_amount || "",
        paid_amount: data?.paid_amount || "",
        balance_amount: data?.balance_amount || "",
        status: data?.status || "",
        cancelled_reason: data?.cancelled_reason || "",
      });
    }
  }, [data]);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const canceltrip = async () => {
    if (!vehiclesId) return;
    try {
      const res = await post(`${URLS.BOOKINGS_CANCEL_VEHICLE}${vehiclesId}/`, {
        cancelled_reason: form?.reason,
      });
      console.log("res", res);
      if (res?.status === "success") {
        toast.success(res?.message);
        setPopup(false);
        setForm({
          reason: "",
        });
        navigation("/booking-management");
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    const raw = sessionStorage.getItem("bookingdata");
    const TabName = sessionStorage.getItem("tabname");
    setTabName(TabName || "");
    let parsed = null;

    if (raw) {
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        parsed = null;
      }
    }

    const resolved = parsed ?? data ?? null;
    const details = resolved?.details;
    const normalizedDetails = Array.isArray(details)
      ? details
      : details
        ? [details]
        : [];

    setbookingData(resolved);
    setPickupLocation(resolved?.pickup_location ?? resolved?.trip_pickup ?? "");
    setDropLocation(resolved?.drop_location ?? resolved?.trip_drop ?? "");
    if (TabName === "Request") {
      setDate(""); // ✅ empty initially
      setTime("");
    } else {
      setDate(resolved?.trip_end || resolved?.trip_end_date || "");

      setTime(resolved?.trip_end_time || resolved?.trip_end_time_text || "");
    }
    console.log("normalizedDetails", normalizedDetails);

    setVehicles(
      normalizedDetails.map((item) => ({
        ...item,
        transport_id: item?.transport_id ?? "",
        vehicle_type_id: item?.vehicle_type_id ?? "",
        vehicle_number_id: item?.vehicle_id ? String(item.vehicle_id) : "",
        amount:
          Number(item?.amount ?? item?.total_amount) === 0
            ? ""
            : (item?.amount ?? item?.total_amount ?? ""),
        driver_id: item?.driver_id ?? "",
        driver_name: item?.driver_name ?? "",
        vehicle_number: item?.vehicle_number ?? "",
        driver_number: item?.driver_number ?? item?.driver_mobile ?? "",
      })),
    );
  }, [data]);

  useEffect(() => {
    if (!bookingData || !vehicles.length) return;

    vehicles.forEach((v, index) => {
      if (v.transport_id) {
        const vehicleListKey = `${index}:${v.transport_id}`;
        if (!loadedVehicleListsRef.current[vehicleListKey]) {
          loadedVehicleListsRef.current[vehicleListKey] = true;
          getVehicleList(v.transport_id, index);
        }

        if (loadedDriversRef.current[index] !== String(v.transport_id)) {
          loadedDriversRef.current[index] = String(v.transport_id);
          getDriversList(v.transport_id, index);
        }
      }

      if (v.transport_id && v.vehicle_type_id) {
        const vehicleNumberKey = `${index}:${v.transport_id}:${v.vehicle_type_id}`;
        if (!loadedVehicleNumbersRef.current[vehicleNumberKey]) {
          loadedVehicleNumbersRef.current[vehicleNumberKey] = true;
          getVehicleNumber(v.transport_id, v.vehicle_type_id, index);
        }
      }
    });
  }, [bookingData, vehicles]);

  console.log("bookingData", bookingData);
  console.log("tabName", tabName);
  console.log("vehicles", vehicles);

  const handleTimeChange = (e) => {
    const value = e.target.value;
    setTime(value);
  };

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setFormattedTime(formatTimeToAmPm(time));
  }, [time]);

  const dateApi = async () => {
    if (!date) {
      toast.error("Please select trip end date");
      return;
    }

    if (!time) {
      toast.error("Please select trip end time");
      return;
    }

    const postData = {
      trip_end: date,
      trip_end_time: formattedTime,
    };

    try {
      setIsLoading(true);
      console.log("postData", postData);
      const res = await post(
        `${URLS.BOOKINGS_TRIP_DATE}${bookingData?.id}/`,
        postData,
      );
      console.log("res", res);
      if (res?.status === "success") {
        toast.success(res?.message);
        // setIsLoading(false);
        if (tabName === "Ongoing") {
          setIsEdit(false);
        } else {
          setIsEdit(true);
        }
      } else {
        toast.error(
          res?.message || "Trip end date cannot be before pickup date",
        );
      }
    } catch (err) {
      console.log("err", err);
      //   setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getAssignTrasnport = async () => {
    const res = await get(URLS.REQUEST_ASSIGN_TRANSPORT);
    if (res?.status === "success") {
      setTransportList(res?.data || []);
    }
  };

  const getVehicleList = async (transportId, index) => {
    const res = await get(
      `${URLS.REQUEST_VEHICLE_SELECT}?transport_id=${transportId}`,
    );
    if (res?.status === "success") {
      setVehicleListsByIndex((prev) => ({
        ...prev,
        [index]: res?.data || [],
      }));
    }
  };

  useEffect(() => {
    getAssignTrasnport();
  }, []);

  const getVehicleNumber = async (transportId, vehicleTypeId, index) => {
    const res = await get(
      `${URLS.REQUEST_VEHICLE_NUMBER}?booking_id=${bookingData?.id}&transport_id=${transportId}&vehicle_type_id=${vehicleTypeId}`,
    );
    if (res?.status === "success") {
      setVehicleNumbersByIndex((prev) => ({
        ...prev,
        [index]: res?.data || [],
      }));
    }
  };

  const getDriversList = async (transportId, index) => {
    const res = await get(
      `${URLS.REQUEST_DRIVERS}?booking_id=${bookingData?.id}&transport_id=${transportId}`,
    );
    if (res?.status === "success") {
      setDriverListsByIndex((prev) => ({
        ...prev,
        [index]: res?.data || [],
      }));
    }
  };

  const updateVehicle = (index, patch) => {
    setVehicles((prev) =>
      prev.map((item, i) => (i === index ? { ...item, ...patch } : item)),
    );
  };

  const clearLoadedByIndex = (ref, index) => {
    Object.keys(ref.current).forEach((key) => {
      if (key.startsWith(`${index}:`)) {
        delete ref.current[key];
      }
    });
  };

  const handleTransportChange = (e, index) => {
    const id = e.target.value;
    updateVehicle(index, {
      transport_id: id,
      vehicle_type_id: "",
      vehicle_number_id: "",
      driver_id: "",
      driver_name: "",
      vehicle_number: "",
      driver_number: "",
    });
    loadedDriversRef.current[index] = "";
    clearLoadedByIndex(loadedVehicleListsRef, index);
    clearLoadedByIndex(loadedVehicleNumbersRef, index);
    setVehicleNumbersByIndex((prev) => ({ ...prev, [index]: [] }));
    if (id) {
      getVehicleList(id, index);
      getDriversList(id, index);
    } else {
      setVehicleListsByIndex((prev) => ({ ...prev, [index]: [] }));
      setDriverListsByIndex((prev) => ({ ...prev, [index]: [] }));
    }
  };

  const handleVehicleChange = (e, index) => {
    const id = e.target.value;
    const transportId = vehicles[index]?.transport_id;
    updateVehicle(index, {
      vehicle_type_id: id,
      vehicle_number_id: "",
    });
    clearLoadedByIndex(loadedVehicleNumbersRef, index);
    if (transportId && id) {
      getVehicleNumber(transportId, id, index);
    } else {
      setVehicleNumbersByIndex((prev) => ({ ...prev, [index]: [] }));
    }
  };

  console.log('vehicleNumbersByIndex', vehicleNumbersByIndex);
  

  const handleVehicleNoChange = (e, index) => {
    const id = e.target.value;
    const numbers = vehicleNumbersByIndex[index] || [];
    const selected = numbers.find((v) => String(v.id) === String(id));
    updateVehicle(index, {
      vehicle_number_id: id,
      vehicle_number: selected?.vehicle_no || "",
    });
  };

  const handleDriverChange = (e, index) => {
    const id = e.target.value;
    const drivers = driverListsByIndex[index] || [];
    const selected = drivers.find((d) => String(d.id) === String(id));
    updateVehicle(index, {
      driver_id: id,
      driver_number: selected?.mobile || "",
      driver_name: selected?.name || "",
    });
  };

  console.log("vehicles", vehicles);

  const handleConfirm = async () => {
    if (!vehicles.length) {
      toast.error("No vehicle details to confirm");
      return;
    }

    for (let i = 0; i < vehicles.length; i++) {
      const v = vehicles[i];
      console.log("v", v);

      if (!v.transport_id) {
        toast.error(`Vehicle ${i + 1}: Please select Transport`);
        return;
      }

      if (!v.vehicle_type_id) {
        toast.error(`Vehicle ${i + 1}: Please select Vehicle Type`);
        return;
      }

      if (!v.vehicle_number_id) {
        toast.error(`Vehicle ${i + 1}: Please select Vehicle Number`);
        return;
      }

      if (!v.driver_id) {
        toast.error(`Vehicle ${i + 1}: Please select Driver`);
        return;
      }

      if (!v.amount) {
        toast.error(`Vehicle ${i + 1}: Please enter Amount`);
        return;
      }

      // 👉 Amount numeric validation (recommended)
      if (isNaN(v.amount) || Number(v.amount) <= 0) {
        toast.error(`Vehicle ${i + 1}: Enter valid Amount`);
        return;
      }

      if (!v.driver_number) {
        toast.error(`Vehicle ${i + 1}: Please enter Driver Number`);
        return;
      }

      // 👉 Driver number validation (10 digits)
      if (!/^[0-9]{10}$/.test(v.driver_number)) {
        toast.error(`Vehicle ${i + 1}: Enter valid Driver Number`);
        return;
      }
    }

    try {
      setIsLoading2(true);

      if (tabName === "Assigned") {
        const postDataAssigned = {
          pickup_address: pickupLocation,
          drop_address: dropLocation,
          details: vehicles.map((v) => ({
            id: v.id,
            transport: Number(v.transport_id),
            vehicle: Number(v.vehicle_number_id),
            driver: Number(v.driver_id),
            total_amount: v.amount ?? "",
            driver_mobile: v.driver_number ?? "",
          })),
        };

        const res = await put(
          `${URLS.ASSIGN_CONFIRM}${bookingData?.id}/`,
          postDataAssigned,
        );
        console.log("res confirm", res);
        if (res?.status === "success") {
          toast.success(res?.message || "");
          navigation("/booking-management");
        }
      } else {
        const postData = {
          details: vehicles.map((v) => ({
            id: v.id,
            transport: Number(v.transport_id),
            vehicle: Number(v.vehicle_number_id),
            driver: Number(v.driver_id),
            total_amount: v.amount ?? "",
            driver_mobile: v.driver_number ?? "",
          })),
        };

        const res = await put(
          `${URLS.REQUEST_BOOKING_CONFIRM}${bookingData?.id}/`,
          postData,
        );
        console.log("res confirm", res);
        if (res?.status === "success") {
          toast.success(res?.message || "");
          navigation("/booking-management");
        }
      }
    } catch (err) {
      console.log("err", err);
      toast.error("Something went wrong");
      //   setIsLoading(false);
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div>
      <Header />

      <div className="add-admin-container">
        {/* Header */}
        <div
          style={{ justifyContent: "space-between" }}
          onClick={() => navigation(-1)}
          className="admin-header"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img src={leftArrow} className="back-icon-arrow" />
            <h2>
              {tabName === "Ongoing"
                ? tabName
                : tabName === "Completed"
                  ? tabName
                  : "Assign Trip"}
            </h2>
          </div>
          {tabName === "Assigned" && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setIsEdit(true);
              }}
              className="button"
            >
              <img src={editBook} className="editBookAA" />
            </div>
          )}
        </div>

        {/* Trip details */}
        <div className="admin-form ">
          <div className="form-groups">
            <label>Trip End Date</label>
            <div className="d-flex ">
              <input
                value={date}
                onChange={(e) => setDate(e.target.value)}
                type="date"
                min={today}
                disabled={!(tabName === "Request" || tabName === "Assigned")}
              />
            </div>
          </div>

          <div className="form-groups">
            <label>Trip End Time</label>
            {/* <div className="d-flex position-relative"> */}

            <div className="d-flex position-relative">
              <input
                type="time"
                ref={hiddenTimeRef}
                value={time}
                onChange={handleTimeChange}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
                disabled={!canEditTime}
                // disabled={!(canEditTime || tabName === "Request" || tabName === "Assigned")}
              />

              <input
                type="text"
                value={formattedTime}
                placeholder="Select Time"
                readOnly
                onClick={() => {
                  if (canEditTime) {
                    hiddenTimeRef.current?.showPicker();
                  }
                }}
              />
              <FontAwesomeIcon
                icon={faClock}
                className="position-absolute end-0 mt-3 me-2"
                style={{ cursor: canEditTime ? "pointer" : "not-allowed" }}
                hidden={!(tabName === "Request" || tabName === "Assigned")}
                onClick={() => {
                  if (canEditTime) {
                    hiddenTimeRef.current?.showPicker();
                  }
                }}
              />
            </div>
          </div>
          {(tabName === "Assigned" ||
            tabName === "Ongoing" ||
            tabName === "Completed") && (
            <>
              <div className="form-groups">
                <label>pickup Location</label>
                <input
                  type="text"
                  placeholder="enter Pickup Location"
                  value={pickupLocation}
                  onChange={(e) => setPickupLocation(e.target.value)}
                  readOnly
                />
              </div>
              <div className="form-groups">
                <label>Drop Location</label>
                <input
                  type="text"
                  placeholder="enter Drop Location"
                  value={dropLocation}
                  onChange={(e) => setDropLocation(e.target.value)}
                  readOnly
                />
              </div>
            </>
          )}
        </div>

        <div>
          {tabName !== "Ongoing" && tabName !== "Completed" && (
            <button
              className="save-btn mt-4"
              onClick={dateApi}
              //  disabled={!date || !time}
              disabled={isLoading}
            >
              {/* submit */}
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "submit"
              )}
            </button>
          )}
        </div>

        {/* VEHICLE LIST */}
        {vehicles.map((item, index) => {
          const currentVehicleTypeId = String(item.vehicle_type_id || "");
          const currentVehicleNumberId = String(item.vehicle_number_id || "");
          const currentDriverId = String(item.driver_id || "");

          const usedDriverIds = vehicles
            .map((v) => String(v.driver_id || ""))
            .filter((id) => id && id !== currentDriverId);
          const usedVehicleTypeIds = vehicles
            .map((v) => String(v.vehicle_type_id || ""))
            .filter((id) => id && id !== currentVehicleTypeId);
          const usedVehicleNumberIds = vehicles
            .map((v) => String(v.vehicle_number_id || ""))
            .filter((id) => id && id !== currentVehicleNumberId);

          const vehicleList = vehicleListsByIndex[index] || [];
          console.log("vehicleList", vehicleList);
          console.log("vehicles", vehicles);

          const vehicleNumber = vehicleNumbersByIndex[index] || [];
          const driverList = driverListsByIndex[index] || [];
          console.log("vehicleNumbersByIndex", vehicleNumbersByIndex);

          return (
            <div key={item?.id ?? index} className="vehicle-box mt-4">
              <h6 className="text-warning mb-3">Vehicle {index + 1}</h6>

              {/* Row 1 */}
              <div className="admin-form d-flex justify-content-between">
                <div className="form-groups col-3">
                  <label>Assign Transport</label>

                  <select
                    className="form-select"
                    disabled={!isEdit}
                    value={item.transport_id}
                    onChange={(e) => handleTransportChange(e, index)}
                  >
                    <option value="" disabled>
                      Select Transport
                    </option>

                    {transportList?.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name} ({t.transport_code})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-groups col-3">
                  <label>Vehicle selection</label>
                  <select
                    className="form-select"
                    disabled={!isEdit}
                    value={item.vehicle_type_id}
                    onChange={(e) => handleVehicleChange(e, index)}
                  >
                    <option value="" disabled>
                      Select Vehicle
                    </option>

                    {vehicleList.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v?.type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-groups col-3">
                  <label>Amount</label>
                  <input
                    type="text"
                    placeholder="Enter the Amount"
                    value={item.amount || ""}
                    onChange={(e) =>
                      updateVehicle(index, { amount: e.target.value })
                    }
                    disabled={!isEdit}
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div className="admin-form d-flex justify-content-between mt-3">
                <div className="form-groups col-3">
                  <label>Vehicle Number</label>
                  <select
                    className="form-select"
                    disabled={!isEdit}
                    value={item.vehicle_number_id || item.vehicle_number || ""}
                    onChange={(e) => handleVehicleNoChange(e, index)}
                  >
                    {!item?.vehicle_number && (
                      <option value="" disabled>
                        Select Vehicle Number
                      </option>
                    )}
                    {!!item?.vehicle_number && (
                      <option value={item.vehicle_number_id || item.vehicle_number}>
                        {item.vehicle_number}
                      </option>
                    )}

                    {vehicleNumber
                      ?.filter(
                        (v) => !usedVehicleNumberIds.includes(String(v.id)),
                      )
                      .map((v) => (
                        <option key={v.id} value={String(v.id)}>
                          {v?.vehicle_no}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="form-groups col-3">
                  <label>Driver selection</label>
                  <select
                    className="form-select"
                    disabled={!isEdit}
                    value={item.driver_id || ""}
                    // value={item.driver_id || item?.driver_name || ""}
                    onChange={(e) => handleDriverChange(e, index)}
                  >
                    <option value="" disabled>
                      Select Driver
                    </option>
                    {driverList
                      ?.filter((d) => !usedDriverIds.includes(String(d.id)))
                      .map((d) => (
                        <option key={d.id} value={d.id}>
                          {d?.name}
                        </option>
                      ))}
                    {!!item?.driver_id &&
                      !driverList?.some(
                        (d) => String(d.id) === String(item.driver_id),
                      ) && (
                        <option value={item.driver_id}>
                          {item.driver_name || `Driver ${item.driver_id}`}
                        </option>
                      )}
                  </select>
                </div>

                <div className="form-groups col-3">
                  <label>Driver Number</label>
                  <input
                    type="text"
                    placeholder="Enter Driver Number"
                    value={item.driver_number}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                      updateVehicle(index, { driver_number: onlyNumbers });
                      //   updateVehicle(index, { driver_number: e.target.value })
                    }}
                    disabled={!isEdit}
                    maxLength={10}
                  />
                </div>
              </div>
              {/* Row 3 */}
              {/* {(tabName === "Completed" || tabName === "Ongoing" ) && ( ![4, 5].includes(item?.status))&&  ( */}
              {(tabName === "Ongoing" || tabName === "Completed") && [4, 5].includes(item?.status) && (
                <div className="admin-form d-flex justify-content-between mt-3">
                  <div className="form-groups col-3">
                    <label>
                      {item?.status === 4
                        ? "Trip Completed Date"
                        : "Trip Cancelled Date"}
                    </label>
                    <div className="d-flex ">
                      <input
                        value={item?.delivered_date || item?.cancelled_date}
                        type="date"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-groups col-3">
                    <label>
                      {item.status === 4
                        ? "Trip Completed Time"
                        : "Trip Cancelled Time"}
                    </label>
                    <div className="d-flex position-relative">
                      {/* Hidden time picker */}
                      <input
                        type="time"
                        ref={hiddenTimeRef}
                        style={{
                          position: "absolute",
                          opacity: 0,
                          pointerEvents: "none",
                        }}
                        // disabled={tabName === "Assigned"}
                      />

                      {/* Visible input */}
                      <input
                        type="text"
                        value={formatTimeToAmPm(
                          item?.delivered_time || item?.cancelled_time,
                        )}
                        placeholder="Select Time"
                        readOnly
                      />
                      <FontAwesomeIcon
                        icon={faClock}
                        className="position-absolute end-0 mt-3 me-2"
                        style={{ cursor: "pointer" }}
                        readOnly
                        hidden
                      />
                    </div>
                  </div>

                  {item.status === 5 ? (
                    <div className="form-groups col-3">
                      <label>Status</label>
                      <input type="text"
                      className="text-danger fw-semibold"
                      value="Cancelled" />
                    </div>
                  ) : (
                    <div className="form-groups col-3">
                      <p></p> 
                    </div>
                  )}
                </div>
              )}

              {/* row 4 */}

              {
                item.status === 5 && (

              <div className = "form-groups col-11">
                   <label className="mt-4">Cancel Reason</label> 
                      <textarea
                rows={3}
                //   type="textbox"
                className=""

                value={item?.cancelled_reason}
                //   onChange={(e) => handleChange("mobile", e.target.value)}
                readOnly={!isEdit}
              />

                </div>
                )
              }


              {/* button */}
              {tabName === "Ongoing" && ![4, 5].includes(item?.status) && (
                <div className="">
                  <button
                    onClick={() => {
                      setPopup(true);
                      setVehiclesID(item?.id);
                    }}
                    className="edit-btn mt-4"
                  >
                    Cancel Trip
                  </button>
                </div>
              )}
            </div>
          );
        })}

        {/* button */}
        {tabName !== "Ongoing" && tabName !== "Completed" && (
          <div className="my-5 admin-form">
            <button className="edit-btn w-100 " onClick={() => navigation(-1)}>
              Back
            </button>

            <button
              className="save-btn w-100"
              onClick={handleConfirm}
              disabled={isLoading2}
            >
              {/* Confirm Trip */}
              {/* {tabName === "Assigned" ? "Save" : "Confirm Trip"} */}
              {isLoading2 ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                ></span>
              ) : tabName === "Assigned" ? (
                "Save"
              ) : (
                "Confirm Trip"
              )}
            </button>
          </div>
        )}
      </div>

      {/* User Switch Confirmation Popup */}
      {popup && (
        <div className="delete-modal-overlay">
          <div className="delete-modal-content">
            {/* <h2 className="f4 mt-4 text-center" style={{ color: "#DE3C1E" }}>
               Trip cancellation
            </h2> */}
            {/* <p className="f3 mt-4 text-center" style={{ color: "#0e0d0d" }}>
             You're changing [Vikram] from <br/> 
             Normal User to Special User.
            </p> */}
            <h3
              className="delete-modal-title"
              //  style={{ color: "#0e0d0d" }}
            >
              Trip Cancellation
            </h3>
            <p className="delete-modal-message">Are u sure to cancel Trip?</p>
            <div className="d-flex justify-content-center mb-4">
              <textarea
                type="text"
                className="textarea-style"
                value={form.reason}
                onChange={(e) => handleChange("reason", e.target.value)}
                //   readOnly={!isEdit}
              />
            </div>
            <div className="delete-modal-actions">
              <button
                onClick={() => setPopup(false)}
                className="delete-btn-cancel w-40"
              >
                Cancel
              </button>
              <button
                // onClick={() => handleLogout(usertype)}
                onClick={canceltrip}
                className="delete-btn-confirm  f2 w-40"
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingAssign;
